import { api } from "api/api";
import { AxiosError } from "axios";
import FamiliaProduto from "model/administracao/cadastro/produto/FamiliaProduto";
import OrigemProduto from "model/administracao/cadastro/produto/OrigemProduto";
import Produto from "model/administracao/cadastro/produto/Produto";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import Deposito from "model/suprimentos/Deposito";
import MovimentoEstoque from "model/suprimentos/MovimentoEstoque";
import Transacao from "model/suprimentos/Transacao";
import { DataTableFilterMeta } from "primereact/datatable";
import { getFilters } from "utils/filterUtils";

class MovimentoEstoqueService {

    pesquisar(page: Pageable, filters: DataTableFilterMeta) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/movimentoEstoque/pesquisar`;
            url += getFilters(filters)
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(movimento: MovimentoEstoque) {
        return new Promise<void>((resolve, reject): void => {
            let url = `/movimentoEstoque/excluir?movimentoJson=${encodeURIComponent(JSON.stringify(movimento))}`;
            api
                .delete(url)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    familias() {
        return new Promise<Array<FamiliaProduto>>((resolve, reject): void => {
            api
                .get(`/movimentoEstoque/familias`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    origens() {
        return new Promise<Array<OrigemProduto>>((resolve, reject): void => {
            api
                .get(`/movimentoEstoque/origens`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getProdutos() {
        return new Promise<Array<Produto>>((resolve, reject): void => {
            api
                .get(`/movimentoEstoque/produtos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getDepositos() {
        return new Promise<Array<Deposito>>((resolve, reject): void => {
            api
                .get(`/movimentoEstoque/depositos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTransacoes() {
        return new Promise<Array<Transacao>>((resolve, reject): void => {
            api
                .get(`/movimentoEstoque/transacoes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }



    getTipoMovimento(tipo: String) {
        if (tipo === "ENTRADA") {
            return "Entrada";
        }
        if (tipo === "SAIDA") {
            return "Saída";
        }
        return "";
    }

    getRelatorio(filters: DataTableFilterMeta) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/movimentoEstoque/report`;
            url += getFilters(filters);
            api
                .get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getRelatorioPrecoMedio(cdProduto: string, dataInicio: Date | null) {

        return new Promise<string>((resolve, reject): void => {
            const filters = {
                cdProduto: cdProduto,
                dataInicio: dataInicio
            }
            let url = `/movimentoEstoque/report/precoMedio`;
            url += "?filters="+encodeURIComponent(JSON.stringify(filters));
            api
                .get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTipos() {
        return [
            { label: 'Entrada', value: 'E' },
            { label: 'Saída', value: 'S' }
        ]

    }
}

export default MovimentoEstoqueService;
